import { Rule, HTMLarkdownOptions, PassDownOptions, FilterPredicate } from 'htmlarkdown';

const CITATION_CLASS_PREFIX = 'citationContainer';

export const citationFilter: FilterPredicate = (element: Element): boolean => {
    return Array.from(element.classList).some(cls => cls.includes(CITATION_CLASS_PREFIX));
};

export const citationRule: Rule = {
    filter: [citationFilter],
    replacement: (element: Element, _options: HTMLarkdownOptions, _parentOptions: PassDownOptions): string => {
        const numberElement = element.querySelector('div[class*="_citation_"]');
        const number = numberElement?.textContent?.trim() ?? '';

        const title = element.getAttribute('title')?.trim() ?? '';

        return `\n${number}. ${title}`;
    }
};
